import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Slide,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../components/Button/Button";
import { TransitionProps } from "@mui/material/transitions";
import API from "../../api/axios";
import { useDispatch } from "react-redux";
import { setToast } from "../../store/slices/toastSlice";

interface AutoRescheduleDialogProps {
  open?: boolean;
  loading?: boolean;
  onClose?: () => void;
  onConfirm?:()=>void;
  resetForm?:boolean;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AutoRescheduleDialog: React.FC<AutoRescheduleDialogProps> = ({
  open = false,
  onClose = () => {},
  onConfirm=(data?:any)=>{},
  loading=false,
  resetForm=false
}) => {
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      reason: "",
    },
    validationSchema: Yup.object({
      reason: Yup.string()
        .required("Reason required")
        .min(3, "Minimum 3 characters required"),
    }),
    onSubmit: (values) => {
        onConfirm(values);
    },
  });
  const handleDialogClose = () => {
    formik.resetForm(); // Reset form state
    if (onClose) onClose();
  };
  const handleReset=()=>{
    formik.resetForm();
  }

  useEffect(()=>{
    if(resetForm){
      handleReset();
    }
  },[resetForm])


  return (
    <Dialog
      maxWidth={"sm"}
      fullWidth
      open={open}
      onClose={handleDialogClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          overflow: "visible",
          borderRadius: "15px",
        },
      }}
    >
      <DialogTitle
        sx={{
          position: "relative",
        }}
      >
        <Typography
          sx={{
            color: "#202224",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            letterSpacing: "0.3px",
          }}
        >
          Auto Reschedule
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleDialogClose}
          sx={{
            position: "absolute",
            right: "-20px",
            top: "-20px",
            height: "44px",
            width: "44px",
            color: "#FB8B0E",
            border: "2px solid #FB8B0E",
            borderRadius: "50% !important",
            padding: 0,
            backgroundColor: "#fff",
            zIndex: 1000,
          }}
          disableRipple
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <form onSubmit={formik.handleSubmit}>
        <DialogContent
          sx={{
            maxHeight: "300px",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Box>
            <TextField
              label="Reason *"
              variant="outlined"
              multiline
              rows={4}
              fullWidth
              id="reason"
              name="reason"
              value={formik.values.reason}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.reason && Boolean(formik.errors.reason)
              }
              helperText={formik.touched.reason && formik.errors.reason}
            />
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "1.5rem",
            justifyContent: "end",
          }}
        >
          <Box>
            <Button
              variant="secondary"
              variantType="outlined"
              label="Cancel"
              style={{ marginRight: "1rem" }}
              onClick={handleDialogClose}
            />
            <Button
              type="submit"
              variant="secondary"
              variantType="contained"
              label="Confirm"
              isLoading={loading}
              disabled={!formik.isValid || !formik.dirty}
            />
          </Box>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AutoRescheduleDialog;
